import {
  WebGLRenderer,
  ACESFilmicToneMapping,
  sRGBEncoding,
  AdditiveBlending
} from 'three'

import {
  EffectComposer,
  RenderPass,
  EffectPass,
  DepthOfFieldEffect,
  SSAOEffect,
  BloomEffect,
  SelectiveBloomEffect,
  SMAAEffect,
  SMAAPreset,
  NormalPass,
  BlendFunction,
  KernelSize,
  EdgeDetectionMode
} from 'postprocessing'

import { gui, guiObj } from '@/utils/gui'

export class Renderer {
  constructor (scene, camera) {
    this.scene = scene
    this.camera = camera

    this.camera.layers.enable( 0 )

    this.resize = this.resize.bind(this)
    this.update = this.update.bind(this)

    this.renderer = new WebGLRenderer({
      alpha: true,
      antialias: false,
      stencil: false,
      preserveDrawingBuffer: false,
      powerPreference: 'high-performance',
    })

    this.renderer.setClearColor(0x000000)
    this.renderer.shadowMap.enabled = false

    this.smaaEffect = new SMAAEffect(
      Object.assign(new Image(), { src: SMAAEffect.searchImageDataURL }),
      Object.assign(new Image(), { src: SMAAEffect.areaImageDataURL }),
      SMAAPreset.MEDIUM,
      EdgeDetectionMode.COLOR
    )

    this.selectiveBloomEffect = new SelectiveBloomEffect(this.scene, this.camera, {
      blendFunction: BlendFunction.SCREEN,
      intensity: 1.2,
      luminanceThreshold: .2,
      luminanceSmoothing: .03,
      kernelSize: KernelSize.MEDIUM
    })
    // this.selectiveBloomEffect.setSize(512, 512)
    // this.selectiveBloomEffect.setSize(2048, 2048)
    this.selectiveBloomEffect.blurPass.scale = 3.5
    this.selectiveBloomEffect.selection.layer = 1

    this.effectPass1 = new EffectPass(this.camera, this.smaaEffect)
    this.effectPass1.renderToScreen = false

    this.renderPass = new RenderPass(this.scene, this.camera)

    this.effectPass2 = new EffectPass(this.camera, this.selectiveBloomEffect)
    this.effectPass2.renderToScreen = true
    this.effectPass2.enabled = true

    this.composer = new EffectComposer(this.renderer)

    this.composer.addPass(this.renderPass)
    this.composer.addPass(this.effectPass1)
    this.composer.addPass(this.effectPass2)

    this.addGui()
  }

  get canvas () {
    return this.renderer.domElement
  }

  resize ({width, height}) {
    this.renderer.setSize(width, height)
    this.composer.setSize(width, height)

    this.camera.aspect = width / height
    this.camera.updateProjectionMatrix()
  }

  update () {
    this.composer.render()
  }

  destroy () {
    // this.renderPass.dispose()
    // this.effectPass1.dispose()
    // this.effectPass2.dispose()
    // this.composer.dispose()
  }

  addGui () {
    const guiBloomSel = gui.addFolder('SelectiveBloom')
    guiBloomSel.add(this.selectiveBloomEffect, 'intensity').min(0).max(5).step(0.01)
    guiBloomSel.add(this.selectiveBloomEffect.blurPass, 'scale').min(0).max(5).step(0.01)
    guiBloomSel.add(this.selectiveBloomEffect.luminanceMaterial, 'threshold').min(0).max(2).step(0.01)
    guiBloomSel.add(this.selectiveBloomEffect.luminanceMaterial, 'smoothing').min(0).max(2).step(0.01)
  }

  set bokeh (value) {
    this.bokehEffect.circleOfConfusionMaterial.uniforms.focalLength.value = value * .06
  }

  get bokeh () {
    return this.bokehEffect.circleOfConfusionMaterial.uniforms.focalLength.value / .06
  }
}
